import { useEffect, useRef, useState } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { submitCoverage } from 'api/coverage-submissions';
import { newsroomError } from 'api/newsroom';
import styles from 'styles/modules/newsAlert/RanThis.module.scss';

// Emails can link to #ran-this, or pass ?ran=<url> to pre-fill the field.
const RanThis = ({ alertId }) => {
    const router = useRouter();
    const inputRef = useRef(null);
    const [url, setUrl] = useState('');
    const [sending, setSending] = useState(false);
    const [error, setError] = useState(null);
    const [done, setDone] = useState(false);

    useEffect(() => {
        if (!router.isReady) return;
        const { ran } = router.query;
        if (typeof ran === 'string' && /^https?:\/\//i.test(ran)) {
            setUrl(ran);
        }
        if (ran !== undefined || router.asPath.includes('#ran-this')) {
            inputRef.current?.scrollIntoView({ block: 'center' });
            inputRef.current?.focus({ preventScroll: true });
        }
    }, [router.isReady]);

    const submit = async (e) => {
        e.preventDefault();
        setSending(true);
        setError(null);
        try {
            await submitCoverage(alertId, url.trim());
            setDone(true);
        } catch (err) {
            setError(newsroomError(err, 'Could not log that link.'));
        } finally {
            setSending(false);
        }
    };

    return (
        <section id="ran-this" className={styles.ranThis}>
            {done ? (
                <p className={styles.thanks} role="status">
                    Thanks, logged. We&rsquo;ll attach it to the experts&rsquo;
                    profiles shortly.{' '}
                    <Link href="/raws">
                        <a>Back to the Raws</a>
                    </Link>
                </p>
            ) : (
                <form className={styles.form} onSubmit={submit}>
                    <label className={styles.label} htmlFor="ran-this-url">
                        Ran this story? Paste the link.
                    </label>
                    <input
                        ref={inputRef}
                        id="ran-this-url"
                        type="url"
                        required
                        value={url}
                        onChange={(e) => setUrl(e.target.value)}
                        placeholder="https://"
                        maxLength={255}
                    />
                    <button type="submit" disabled={sending}>
                        {sending ? 'Sending…' : 'Submit'}
                    </button>
                </form>
            )}
            {error && <p className={styles.error}>{error}</p>}
        </section>
    );
};

export default RanThis;
